<template>
  <div class="header-menus">
    <el-menu :default-active="activeMenu" mode="horizontal" style="display:flex;" @select="selected">
      <el-menu-item :index="item._path" v-if="item.meta.hidden!=true" v-for="item in routes">
        {{item.meta.title}}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import AppLink from "./Link";
  import path from "path";
  import {isExternal} from "@/utils/validate";

  export default {
    name: "HeaderMenus",
    components: {AppLink},
    data() {
      return {
        activeIndex: "1",
        routes: [],
        basePath: "/"
      };
    },
    computed: {
      ...mapGetters([
        'permission_routes',
        'sidebar'
      ]),
      activeMenu() {
        const route = this.$route;
        const {meta, path} = route;
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        let tA = path.split("/");
        if (!tA[1] || tA[1] == "dashboard") {
          return "/";
        }
        return "/" + tA[1];
      },
    },
    watch: {
      $route(to, from) {
        this.initroutes();
      }
    },
    created() {
      this.initroutes();
    },
    methods: {
      initroutes() {
        let routes = [];
        this.permission_routes.forEach(ele => {
          if (ele.hidden) {
            return;
          }
          ele._path = ele.path;
          ele._pathKey = ele.path;
          if (ele.meta && ele.meta.title && ele.path) {
            if (ele.children && ele.children.length > 0) {
              if (!ele.alwaysShow) {
                if (ele.children[0].children) {
                  ele._pathKey = ele.children[0].children[0].path;
                } else {
                  ele._pathKey = ele.children[0].path;
                }
              } else {
                ele._pathKey = ele.path + "/" + ele.children[0].path;
              }
            }
            routes.push(ele);
          }
        });
        this.routes = routes;
        this.getSubRoute(this.activeMenu)
      },
      resolvePath(routePath) {
        if (isExternal(routePath)) {
          return routePath;
        }
        if (isExternal(this.basePath)) {
          return this.basePath;
        }
        return path.resolve(this.basePath, routePath);
      },
      getSubRoute(path) {
        let routes = []
        let parentName = ''
        let b = false
        this.permission_routes.forEach(ele => {
          if (b) {
            return
          }

          if (ele.path != path) {
            return
          }

          if (ele.name === 'Dashboard') {
            return;
          }

          if (!ele.children || ele.children.length == 0) {
            return
          }
          parentName = ele.meta.title
          routes = ele.children
          b = true
        });

        this.$emit('refresh', routes, parentName)
      },
      selected(path, indexPath) {
        this.routes.forEach(ele => {
          if (ele._path == path) {
            this.$router.push({path: ele._pathKey})
          }
        })

        this.getSubRoute(path)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebarLogoFade-enter,
  .sidebarLogoFade-leave-to {
    opacity: 0;
  }

  .sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #2b2f3a;
    text-align: center;
    overflow: hidden;

    & .sidebar-logo-link {
      height: 100%;
      width: 100%;

      & .sidebar-logo {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        margin-right: 12px;
      }

      & .sidebar-title {
        display: inline-block;
        margin: 0;
        color: #fff;
        font-weight: 600;
        line-height: 50px;
        font-size: 14px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        vertical-align: middle;
      }
    }

    &.collapse {
      .sidebar-logo {
        margin-right: 0px;
      }
    }
  }
</style>
